import { render } from "./BtnsONOFF.vue?vue&type=template&id=299d0a74&scoped=true"
import script from "./BtnsONOFF.vue?vue&type=script&lang=js"
export * from "./BtnsONOFF.vue?vue&type=script&lang=js"

import "./BtnsONOFF.vue?vue&type=style&index=0&id=299d0a74&lang=scss&scoped=true"

import exportComponent from "/opt/app-root/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-299d0a74"]])

export default __exports__